import * as mutation from "./mutation-types";
import { stateMerge } from "vue-object-merge";
import { getBlankRecord } from "./helpers";
import { getInitialState, getUnloadedState } from "./state";

export const mutations = {
  [mutation.STATE_RESET](state) {
    stateMerge(state, getInitialState());
  },
  [mutation.STATE_UNLOAD](state) {
    stateMerge(state, getUnloadedState());
  },
  [mutation.STATE_HIDE_ERROR](state, hideArgument) {
    stateMerge(state[hideArgument], { error: { show: false } });
  },

  [mutation.LIST_SET_FILTERS](state, { levyCollectionId }) {
    state.listing.levyCollectionId = levyCollectionId;
  },
  [mutation.LIST_SET_PAGING](state, paging) {
    stateMerge(state.listing.paging, paging);
  },
  [mutation.LIST_STARTED](state) {
    state.listing.loading = true;
  },
  [mutation.LIST_FAILED](state) {
    state.listing.loading = false;
  },
  [mutation.LIST_SUCCEEDED](state, data) {
    state.listing.loading = false;
    state.listing.loaded = true;
    state.listing.data = data;
  },

  [mutation.EDIT_SET_DATA](state, template) {
    state.edit.data.template = template;
  },
  [mutation.EDIT_GET_STARTED](state, { levyCollectionId, type }) {
    state.edit.loading = true;
    state.edit.error.show = false;
    state.edit.levyCollectionId = levyCollectionId;
    state.edit.type = type;
    state.edit.data = getBlankRecord();
  },
  [mutation.EDIT_GET_FAILED](state) {
    state.edit.loading = false;
  },
  [mutation.EDIT_GET_SUCCEEDED](state, template) {
    state.edit.loading = false;
    stateMerge(state.edit.data, template);
  },

  [mutation.EDIT_SAVE_STARTED](state) {
    state.edit.saving = true;
    state.edit.error.show = false;
  },
  [mutation.EDIT_SAVE_FAILED](state, error) {
    state.edit.saving = false;
    state.edit.error.show = true;
    state.edit.error.details = error;
  },
  [mutation.EDIT_SAVE_SUCCEEDED](state) {
    state.edit.saving = false;
  },

  [mutation.EXPORT_SPREADSHEET_STARTED](state) {
    state.listing.loading = true;
  },
  [mutation.EXPORT_SPREADSHEET_SUCCEEDED](state) {
    state.listing.loading = false;
  },
  [mutation.EXPORT_SPREADSHEET_FAILED](state) {
    state.listing.loading = false;
  },

  [mutation.EXPORT_JSON_STARTED](state) {
    state.listing.loading = true;
  },
  [mutation.EXPORT_JSON_SUCCEEDED](state) {
    state.listing.loading = false;
  },
  [mutation.EXPORT_JSON_FAILED](state) {
    state.listing.loading = false;
  }
};
